// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-682e2c42]{overflow:auto;height:100%}.item-root[data-v-682e2c42]{margin-left:0!important}", ""]);
// Exports
module.exports = exports;
